/// <amd-module name="Build/PipelinesLanguage/Services/LanguageEditorService" />
import { JSONSchema } from "AzurePipelinesLanguageService";
import { CodeLensOptions, ILanguageEditorService } from "Build/Common/Library/Contracts";
import { Services, VssService } from "VSS/Platform/Context";
import { AzurePipelinesLanguageExtension } from "../AzurePipelinesLanguageExtension";
import { monacoLanguageRegistrationService } from "./MonacoLanguageRegistrationService";

class LanguageEditorService extends VssService implements ILanguageEditorService {
    private languageExtension?: AzurePipelinesLanguageExtension;

    public initializeEditor(editor: monaco.editor.IStandaloneCodeEditor,codeLensOptions?: CodeLensOptions) {
        if (this.languageExtension) {
            this.languageExtension.dispose();
        }

        this.languageExtension = AzurePipelinesLanguageExtension.register(
            this.pageContext,
            editor,
            monacoLanguageRegistrationService(),
            codeLensOptions
        );
    }

    public _serviceEnd() {
        if (this.languageExtension) {
            this.languageExtension.dispose();
        }
    }

    public useSchema(schema: JSONSchema) {
        this.languageExtension?.useSchema(schema);
    }
}

Services.add("ILanguageEditorService", { serviceFactory: LanguageEditorService });
